<p-table [columns]="data.columns" [value]="data.rows" [scrollable]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let col of data.columns; let colIndex = index">
        <ng-container
          *ngTemplateOutlet="
            col.main ? headerFirstColumn : headerColumn;
            context: { colData: col }
          "
        >
        </ng-container>
      </ng-container>
  </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of data.columns; let colIndex = index">
          <ng-container
            *ngTemplateOutlet="
              col.main ? bodyFirstColumn : bodyColumn;
              context: { colData: col, rowData: rowData }
            "
          >
          </ng-container>
        </ng-container>
      </tr>
  </ng-template>
</p-table>

<ng-template #headerFirstColumn let-colData="colData">
  <th pFrozenColumn [frozen]="colData.main" style="min-width:200px">
    {{ colData.label }}
  </th>
</ng-template>

<ng-template #headerColumn let-colData="colData">
  <th style="min-width:100px">
    {{ colData.label }}
  </th>
</ng-template>

<ng-template #bodyFirstColumn let-colData="colData" let-rowData="rowData">
  <td pFrozenColumn [frozen]="colData.main">
    {{ rowData.cells[colData.key].value }}
  </td>
</ng-template>

<ng-template #bodyColumn let-colData="colData" let-rowData="rowData">
  <td>
    <span
      [class.text-nowrap]="colData.config?.wrap == 'nowrap'"
      [class.text-wrap]="colData.config?.wrap == 'wrap'"
      [class.text-left]="colData.config?.alignment == 'left'"
      [class.text-center]="colData.config?.alignment == 'center'"
      [class.text-right]="colData.config?.alignment == 'right'"
      [style.color]="rowData.cells[colData.key].textColour"
      >{{ rowData.cells[colData.key].value }}</span
    >
  </td>
</ng-template>
